<app-image-upload
    [name]="formControlName"
    [formControl]="control"
    [accept]="acceptedContentTypes"
    (fileChange)="onLogoSelected($event)"
    [fixedWidth]="width"
    [fixedHeight]="height">
</app-image-upload>